import { render, staticRenderFns } from "./CampaignsSummaryTable.vue?vue&type=template&id=ed8ff0c2&scoped=true&"
import script from "./CampaignsSummaryTable.vue?vue&type=script&lang=js&"
export * from "./CampaignsSummaryTable.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsSummaryTable.vue?vue&type=style&index=0&id=ed8ff0c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8ff0c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed8ff0c2')) {
      api.createRecord('ed8ff0c2', component.options)
    } else {
      api.reload('ed8ff0c2', component.options)
    }
    module.hot.accept("./CampaignsSummaryTable.vue?vue&type=template&id=ed8ff0c2&scoped=true&", function () {
      api.rerender('ed8ff0c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/campaigns/CampaignsSummaryTable.vue"
export default component.exports